<template>
    <div class="app-container">
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">

            <!-- 上级目录 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="上级目录">
                        <el-cascader
                            clearable
                            ref="getDefaultValue"
                            v-model="form.parent_id"
                            :props="propsData"
                            :show-all-levels='false'>
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 目录名称 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="目录名称" prop="name">
                        <el-input v-model="form.name" placeholder="请填写目录名称"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 目录图标 -->
            <!-- <el-row>
                <el-col :span='12'>
                    <el-form-item label="目录图标">
                        <img :src="searchRequery.url" alt="" style='width: 20px;height: 20px;marginRight: 10px;'>
                        <el-select v-model="form.img_url" placeholder="请选择应用类型" clearable @change='defImgChang'>
                            <el-option v-for="item in listAll.img_list" :key="item.url" :label="item.title" :value="item.url"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->

            <!-- 图标上传 -->
            <el-row>
                <el-col :span='24'>
                    <el-form-item label="图标上传">
                        <!--<img v-if='form.img_url !== ""' :src="form.img_url" alt="">-->
                        <img v-if="form.img_url" :src="form.img_url" alt="">
                        <router-link :to="{ path: '/unLoad',
                                            query: {
                                                type: 'app',
                                                id: type === 'edit' ? appnodeId : '',
                                                callback: getImage
                                            }
                                        }">
                            <el-button type="success">选择头像</el-button>
                        </router-link>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 负责人 -->
            <el-row>
                <el-col>
                    <el-form-item label="负责人" prop='superviser' ref='superviser'>
                        <el-select
                            v-model="form.superviser"
                            :remote-method="(query) => remoteMethodUser(query)"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change='changeUser("superviser")'>
                            <el-option
                                v-for="item in listAll.user_list"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 邮件组 -->
            <el-row>
                <el-col>
                    <el-form-item label="邮件组" prop='mails'>
                        <el-tag
                            :key="tag"
                            v-for="tag in form.mails"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm">
                        </el-input>
                        <img class='mailBtn' src="../../../assets/mails.png"  @click="showInput">
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span='24'>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                        <el-button type='info' @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import services from "../cicd.services"
    import { getRules } from '../cicd.rules'

    const rules = getRules()

    export default {
        props: {
            type: {
                type: String,
                default: "add"
            },
            appnodeId: String | Number,
            callback: Function,
            count: {
                type: Object,
                default: {}
            }
        },

        // watch: {
        //     listAll: {
        //         handler(newName, oldName) {
        //             this.searchRequery.url = newName.img_list[0].url
        //             this.form = {
        //                     ...this.form,
        //                     img_url: newName.img_list[0].url
        //                 }
        //         },
        //         deep: true,
        //     },
        // },

        data() {
            return {
                loading: false,
                listAll: {
                    img_list: [],
                    user_list: []
                },
                form: {
                    name: "",
                    superviser: [],
                    mails: [],
                    img_url: ''
                },
                rules: rules,
                param_data: {},
                searchRequery: {},
                propsData: {
                    lazy: true,
                    leaf: 'leaf',
                    checkStrictly: true,
                    lazyLoad: (node, resolve) => this.lazyLoad (node, resolve)
                },
                userList: [],
                inputValue: [],
                userTagList: [],
                inputVisible: false,
                inputValue: ''
            };
        },

        created() {
            if (this.type === 'edit') {
                this.$modal.title = "编辑目录";
                this.getDetailForm()
            }
        },

        mounted() {
            // console.log(this.count,'count');
            this.requestDefault()
            // if (this.type == 'add') {
            //     this.form.parent_id = this.count.id
            //     this.count.name && (this.$refs.getDefaultValue.$el.children[0].children[0].value = this.count.name)
            // }
        },

        methods: {
            // 获取图片
            getImage(val) {
                this.form.img_url = val;
            },
            handleClose(tag) {
                this.form.mails.splice(this.form.mails.indexOf(tag), 1);
                this.userTagList.push('mails')
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                this.userTagList.push('mails')
                if (inputValue) {
                    let re=/^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
                    if (re.test(inputValue)) {
                        this.form.mails.push(inputValue);
                    } else {
                        this.$message.error('请输入正确的邮箱')
                    }
                }
                this.inputVisible = false;
                this.inputValue = '';
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },


            // 请求详情
            getDetailForm() {
                services.nodeInfo({appId:this.appnodeId})
                    .then(res => {
                        this.form = {
                            ...res,
                            superviser: res.superviser.map(item => item.name),
                            mails: res.mail.map(item => item.mail)
                        }
                        this.$refs.getDefaultValue.$el.children[0].children[0].value = this.form.parent_name || ''
                        this.userList = {
                            superviser: res.superviser,
                        }
                    })
                    .catch(err => this.$message.error(err.message))
            },

            // 人员被改变时
            changeUser(title) {
                this.userTagList.push(title)
            },

            // 请求默认数据
            requestDefault() {
                // 请求默认图片
                services.imgList()
                    .then(res => this.listAll.img_list = res)
                    .catch((err) => this.$message.error(err.message))
            },

            // 默认图片被改变时
            defImgChang(val) {
                this.searchRequery.url = val
            },

            // 上传文件
            changeFn(e){
                let files = e.target.files || e.dataTransfer.files
                let params = {
                    file_name : files[0]
                };
                services.upload(params)
                    .then(res => this.form.img_url = res.download_url)
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.$message.success("导入成功"))
            },

            // 加载联动菜单
            lazyLoad (node, resolve) {
                const { level } = node;
                if(!level){
                    services.treeLevel1()
                        .then(res => {
                            let nodes = res.list.map(item=>({
                                value: item.id,
                                label: item.name,
                                leaf:item.is_folder ? false : true,
                                id: item.id
                            }))
                            nodes = nodes.filter(item => !item.leaf)
                            resolve(nodes)
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => this.loading = false)
                }else{
                    services.treeChildren({ id: node.value })
                        .then(res => {
                            let nodes = res.list.map(item=>({
                                value: item.id,
                                label: item.name,
                                leaf:item.is_folder ? false : true,
                                id: item.id
                            }))
                            nodes = nodes.filter(item => !item.leaf)
                            resolve(nodes)
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => this.loading = false)
                }
            },

            // 设置请求数据
            setRequest() {
                return {
                    name: this.form.name,
                    img_url: this.form.img_url,
                    id: this.form.id,
                    mails: this.form.mails,
                    superviser: this.type === "add" ? this.form.superviser.map(item => JSON.parse(item)) : this.setUser('superviser'),
                    parent_id: (typeof(this.form.parent_id) === 'object' ? this.form.parent_id[this.form.parent_id.length - 1] : this.form.parent_id) | 0,
                    userTagList: this.userTagList,
                }
            },

            // 搜索人员
            remoteMethodUser(query) {
                if (query !== '') {
                    this.loading = true
                    services.filterUser(query)
                        .then(res => {
                            let list = []
                            for (let item in res.user_data) {
                                list.push({
                                    value: JSON.stringify(res.user_data[item]),
                                    label: res.user_data[item] && res.user_data[item].name + '(' + item + ')'
                                })
                            }
                            this.loading = false
                            this.listAll.user_list = list
                        })
                        .catch(err => this.$message.error(err.message))
                } else {
                    this.listAll.user_list = []
                }
            },


            // 设置人员
            setUser(title) {
                let arr = []
                this.form[title].forEach(item => {
                    if (item.length > 20) {
                        arr.push(JSON.parse(item))
                    } else {
                        let filterArr = this.userList[title].filter(i => i.name === item)
                        if (filterArr.length) arr.push(filterArr[0])
                    }
                })
                return arr;
            },

            // 点击确定
            onSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {

                        const loading = this.$loading({
                            lock: true,
                            text: "Loading",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.7)"
                        })
                        if (this.type === 'edit') {
                            this.folderEdit(loading)
                        } else {
                            this.folderAdd(loading)
                        }

                    } else {
                        return false;
                    }
                });
            },

            folderEdit(loading) {
                const params = this.setRequest()
                services.updateMenu(params)
                    .then(response => this.$message.success('编辑目录成功'))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close()
                        this.$modal.close()
                        this.callback({id: this.appnodeId})
                        // console.log(1);
                        this.$nextTick()
                    })
            },

            folderAdd(loading) {
                loading.close()
                const params = this.setRequest()
                // console.log(params, 'dddddddddddddd')
                services.folderAdd(params)
                    .then(response => this.$message.success('创建目录成功'))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close()
                        this.$modal.close()
                        this.callback({id: this.appnodeId})
                        this.$nextTick()
                    })
            },

            // 点击取消
            onCancel() {
                this.$modal.close()
            },

            // 搜索人员
            remoteMethod(query) {
                if (query !== "") {
                    this.loading = true
                    services.filterUser(query)
                        .then(res => {
                            let list = []
                            for (let item in res.user_data) {
                                list.push({
                                    value: JSON.stringify(res.user_data[item]),
                                    label: res.user_data[item] && res.user_data[item].name + '(' + item + ')'
                                })
                            }
                            this.loading = false
                            this.listAll.user_list = list
                        })
                        .catch(err => this.$message.error(err.message))
                } else {
                    this.listAll.user_list = []
                }
            },
        }
    };
</script>

<style lang="scss" scoped>

    .file {
        position: relative;
        display: inline-block;
        background: #67c23a;
        border: 1px solid #67c23a;
        border-radius: 4px;
        padding: 4px 12px;
        overflow: hidden;
        color: #fff;
        text-decoration: none;
        text-indent: 0;
        line-height: 16px;
        vertical-align: middle;
        input {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
        }
    }

    img {
        width: 20px;
        height: 20px;
        margin: 0 10px;
        vertical-align: middle;
    }
    .mailBtn {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        margin-top: 5px;
    }
</style>
